import {
  ActivityTeaserFragmentFragment,
  MerchantTeaserFragmentFragment,
  TermCategory,
} from '../../../generated/types';
import Card from '../../Common/Card';
import Location from '../../Common/Location';
import React from 'react';
import ActivityCategoryBadge from '../../Common/ActivityCategoryBadge';
import { TeaserProps } from '../../../types/global-types';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Link } from '@chakra-ui/react';
import { MerchantMapMarkerIcon } from '../../../config/icons';

type MerchantTeaserProps = TeaserProps & {
  data: MerchantTeaserFragmentFragment;
  number?: number;
  onClickShowOnMap?: (d: MerchantTeaserFragmentFragment) => void;
};

const MerchantTeaser: React.FC<MerchantTeaserProps> = ({
  data,
  number,
  onClickShowOnMap,
  ...rest
}) => {
  const onClickShowOnMapButton = () => {
    if (onClickShowOnMap && data) {
      onClickShowOnMap(data);
    }
  };

  return (
    <Box>
      <Flex alignItems="center" marginBottom={2}>
        <MerchantMapMarkerIcon
          color="textColor"
          width="29px"
          height="38px"
          mr={2}
        />
        {data.company && <Box fontWeight="bold">{data.company}</Box>}
      </Flex>
      <Box>{data.street}</Box>
      <Box>
        {data.postcode} {data.city}
      </Box>
      {data.phone || data.homepage ? (
        <Box marginTop={2}>
          {data.phone && <Box>Tel.: {data.phone}</Box>}
          {data.homepage && (
            <Box>
              <Link href={data.homepage} target="_blank" isExternal>
                {data.homepage} <ExternalLinkIcon mx="2px" />
              </Link>
            </Box>
          )}
        </Box>
      ) : null}
      {onClickShowOnMap && (
        <Button marginTop={4} size="xs" onClick={onClickShowOnMapButton}>
          Auf der Map anzeigen
        </Button>
      )}
    </Box>
  );
};

export default MerchantTeaser;
